<ng-container *transloco="let t; read: 'PARAMETERS_MODAL_COMPONENT'">
  <ion-toolbar>
    <div class="toolbar-header">
      <ion-button (click)="dismissModal()" fill="none" color="secondary">
        <ion-icon slot="icon-only" name="arrow-back-outline"></ion-icon>
      </ion-button>
      <h1>{{ t('TITLE') }}</h1>
      <div class="right"></div>
    </div>
  </ion-toolbar>
  <ion-content class="ion-padding">
    <div class="mx-32-desktop">
      <h3>{{ t('THEME') }}</h3>
      <app-themes-select></app-themes-select>
      <h3>{{ t('LANGUAGE') }}</h3>
      <app-languages-select></app-languages-select>
      <h3>Configuration</h3>
      <div class="card-compact-list">
        <app-account-mini-card [title]="t('HANDLE_COOKIES')" icon="/assets/svg/cookies.svg" (click)="showCookiesConfig()"></app-account-mini-card>
        <app-account-mini-card [title]="t('HANDLE_NOTIFS')" icon="notifications" (click)="showNotificationsConfig()"></app-account-mini-card>
      </div>
    </div>
  </ion-content>
</ng-container>
